function setBodyBusy(set=true, overlayOnly=false) {
	if (overlayOnly) {
		if (set) {
			document.getElementsByTagName('body')[0].classList.add('busy-overlay')
		} else {
			document.getElementsByTagName('body')[0].classList.remove('busy-overlay')
		}
	} else {
		if (set) {
			document.getElementsByTagName('body')[0].classList.add('busy')
		} else {
			document.getElementsByTagName('body')[0].classList.remove('busy')
		}
	}
}

export { setBodyBusy }
